module.exports = __webpack_public_path__ + "static/img/resume-oblique-rtl.a9bfb54.png";